/**
 * Created by SH on 28/7/2019.
 */

import { ISymbolConfig } from "../../../core/reel/symbol/config/IReelSymbolStruct";
import { SymbolData } from "../../../core/reel/symbol/config/SymbolData";

export enum ReelSymbolSize {
    ONE = 1, TWO = 2, THREE = 3,
    FOUR = 4, FIVE = 5, SIX = 6,
    SEVEN = 7, EIGHT = 8, TEN = 10,
}

export interface SymValue {
    [name: string]: SymValueData;
}
export interface SymValueData {
    [name: string]: SymValueDataData;
}
export interface SymValueDataData {
    [name: string]: number;
}

export class SanSymbolData extends SymbolData {

    protected preDefinedSymbols: ISymbolConfig[] = [
        {
            NAME: "S",
        },
        {
            NAME: "W",
            MULTI_STATES: {
                "2": {
                    win: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 90,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W2_Win",
                    },
                    idle: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 90,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W2_Win",
                    },
                },
                "4": {
                    win: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W4_Win",
                    },
                    idle: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W4_Win",
                    },
                    police: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_J/4/JW_Policeman",
                    },
                },
            },
        },
        // ----------
        {
            NAME: "L1",
        },
        {
            NAME: "L2",
        },
        {
            NAME: "L3",
        },
        {
            NAME: "L4",
        },
        {
            NAME: "L5",
        },
        {
            NAME: "M1",
        },
        {
            NAME: "M2",
        },
        {
            NAME: "M3",
        },
        {
            NAME: "M4",
        },
        {
            NAME: "M5",
        },
        {
            NAME: "FSKEY",
            NORMAL_STATES: {
                spin: {
                    DIM: {
                        WIDTH: 136,
                        HEIGHT: 148,
                        PADDING_X: 4,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: "M5/4/M5_spin",
                },
                normal: {
                    DIM: {
                        WIDTH: 136,
                        HEIGHT: 148,
                        PADDING_X: 4,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: "M5/4/M5_normal",
                },
            }
        },
        {
            NAME: "X",
            NORMAL_STATES: {
                spin: {
                    DIM: {
                        WIDTH: 136,
                        HEIGHT: 148,
                        PADDING_X: 4,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: "X/X_spin",
                },
                normal: {
                    DIM: {
                        WIDTH: 136,
                        HEIGHT: 148,
                        PADDING_X: 4,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: "X/X_normal",
                },
                normal2: {
                    DIM: {
                        WIDTH: 136,
                        HEIGHT: 148,
                        PADDING_X: 4,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: "X/X_normal2",
                },
                normal3: {
                    DIM: {
                        WIDTH: 136,
                        HEIGHT: 148,
                        PADDING_X: 4,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: "X/X_normal3",
                },
                normal4: {
                    DIM: {
                        WIDTH: 136,
                        HEIGHT: 148,
                        PADDING_X: 4,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: "X/X_normal4",
                }
            }
        },
        {
            NAME: "Z",
            NORMAL_STATES: {
                spin: {
                    DIM: {
                        WIDTH: 136,
                        HEIGHT: 148,
                        PADDING_X: 4,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: "Z/Z_spin",
                },
                normal: {
                    DIM: {
                        WIDTH: 136,
                        HEIGHT: 148,
                        PADDING_X: 4,
                        PADDING_Y: 0,
                        SCALE: new PIXI.Point(1, 1),
                    },
                    TEXTURE_PATH: "Z/Z_normal",
                },
            }
        },
        {
            NAME: "W_J",
            MULTI_STATES: {
                "2": {
                    normal: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 90,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_J/2/JW",
                    },
                    spin: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 90,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_J/2/JW_BG",
                    },
                    empty: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 90,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_J/2/JW_Empty",
                    }
                },
                "4": {
                    normal: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_J/4/JW"
                    },
                    spin: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_J/4/JW_BG",
                    },
                    attention: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "JW_Reveal",
                    },
                    police: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_J/4/JW_Policeman",
                    },
                    empty: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_J/4/JW_Empty",
                    }
                },
            }
        },
        {
            NAME: "XS",
            MULTI_STATES: {
                "2": {
                    normal: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148/2,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "Splitter/Splitter_normal",
                    },
                    spin: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148/2,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "Splitter/Splitter_spin",
                    }
                },
            }
        },
        {
            NAME: "XWAYS",
            MULTI_STATES: {
                "2": {
                    normal: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148/2,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "M/2/M_normal",
                    },
                    spin: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148/2,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "M/2/M_normal",
                    }
                },
            }
        },
        {
            NAME: "W_S",
            MULTI_STATES: {
                "1": {
                    normal: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 37,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W/1/W_normal",
                    },
                    spin: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 37,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W/1/W_spin",
                    }
                },
                "2": {
                    win: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 90,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W2_Win",
                    },
                    idle: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 90,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W2_Win",
                    },
                    normal: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W/2/W_normal",
                    },
                    spin: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W/2/W_spin",
                    }
                },
                "4": {
                    idle: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_Split_Win",
                    },
                    normal: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_S/WS_normal",
                    },
                    spin: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_S/WS_spin",
                    },
                    landing: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_Split_Land",
                    },
                    win: {
                        DIM: {
                            WIDTH: 136,
                            HEIGHT: 148,
                            PADDING_X: 4,
                            PADDING_Y: 0,
                            SCALE: new PIXI.Point(1, 1),
                        },
                        TEXTURE_PATH: "W_Split_Win",
                    }
                },
            }
        },
    ];

    public static fetchSymHeightSize(val: number): number {
        switch (val) {

            case 7:
                return 370;
            case 4:
                return 148;
            case 2:
                return 74;
            case 1:
                return 37;
            default:
                return 148;
        }
    }

    public static fetchSizeTimesSize(symName: string, state: string, sizeType?: string): number {
        return this.fetchSymHeightSize(parseInt(sizeType!));
    }

    public static getAllConfigs(): ISymbolConfig[] {
        return this.configs;
    }
}